module.exports = __webpack_public_path__ + "img/ico-vendeygestiona.c0993087.svg";